import React, { Fragment } from "react";
import {Link} from 'react-router-dom'
import moment from 'moment';
import ReactFancyBox from 'react-fancybox'
import 'react-fancybox/lib/fancybox.css'


import {
    FacebookShareButton,
    // GooglePlusShareButton,
    TwitterShareButton,
    VKShareButton,
} from 'react-share';

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");

function getButton(pack, isLoggedIn, onBuyClick) {

    if(!pack.purchased && isLoggedIn) {
        return  <div className="big-button small-button buy-list-btn" style={{marginBottom:0}}>
                    <button
                        /*disabled={(!isLoggedIn || pack.purchased) ? true : false}*/
                        onClick={()=> onBuyClick(pack)}>
                        Купить
                    </button>
                </div>
    }

    else if(!isLoggedIn) {
        return  <div className="big-button small-button buy-list-btn" style={{marginBottom:0}}>
                    <Link className="big-button without-shadow" style={{maxWidth: '200px', height:'44px'}} to="/signin">
                        <button className="btn-buy" style={{padding:0, height:'44px'}}>
                            Купить
                        </button>
                    </Link>
                </div>
    }

    else if(pack.purchased && pack.purchased_by) {
        return  <div className="big-button small-button buy-list-btn" style={{marginBottom:0, zIndex: 0}}>
                    <a href={pack.zip_archive} target="_blank">
                    <button style={{background: '#65b965'}}>
                        Скачать
                    </button>
                    </a>
                </div>
    }
}

class OrderListItem extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
      };
    }

    render() {
        const pack = this.props.item;

        let likeTitle = '';
        if(!this.props.session.isLoggedIn) likeTitle = 'Проголосовать могут только зарегистрированные пользователи';

        let photos = pack.photos || [];
        let videos = pack.videos || [];
        let packResults = [...photos, ...videos];
        let executors = pack.executors.map((executor, index) => {
          return <Fragment  key = {executor.id}>
            <Link to={`/profile/${executor.id}`}>{`${executor.first_name} ${executor.last_name}`}</Link> 
            {pack.executors.length === index + 1 ? '' : ', '}
          </Fragment>
          
        })

    return(
        <li className="list-item ready-order">
            <div className="top">
                <Link to={`/buy/single/${pack.id}`} className="caption">{pack.title}</Link>
                <strong className="price">
                    {pack.price ? pack.price + ' руб.' : '0  руб.'}
                </strong>
            </div>

            <div>
                Владелец: <Link to={`/profile/${pack.user.id}`}>{`${pack.user.first_name} ${pack.user.last_name}`}</Link>
            </div>
            <div style = {{margin: '10px 0', flexWrap: 'wrap'}}>
                Автор: { !!executors.length ? executors : ' - ' }
            </div>
            <div>{`Дата создания: ${moment(pack.created_at).format("DD.MM.YYYY")}`}</div>

            <div className="desc" style={{marginTop: '5px',marginBottom:'5px'}}>{pack.description}</div>
            {
                pack.purchased_by ?
                <div className="desc" style={{marginTop: '5px',marginBottom:'5px'}}>
                    <span className="pr-tag-name">{pack.purchased_by}</span>
                </div>
                : null
            }

            <div className="actions buy-list" style={{marginTop:'15px'}}>

                {
                    packResults.length ?
                    <ul className="photos buy-list-photos" style={{marginBottom: '15px', flexDirection: 'row', display: 'flex', flexWrap: 'wrap'}}>
                    {
                            packResults.map((photo, index) => {
                                if(index > 9) return false;
                                let more = (index === 9 && packResults.length > 10) ? true : false;

                                return  <li
                                            key={photo.id}
                                            className={`photo ${more ? 'photo-shadow' : ''}`}>
                                            {
                                                photo.video ?
                                                <div style={{height:'100px',width:'100px',position:'relative',zIndex:1}}>
                                                    <a href={photo.video} data-fancybox className="mm-video">
                                                        <i className="play-icon-video"></i>
                                                        <img style={{borderRadius:'20px'}} src={photo.thumb_image} />
                                                    </a>
                                                </div>
                                                :

                                                <div>
                                                  <a className="img" href={photo.image || photo.thumb_image} data-fancybox data-src = {`#forCaption${photo.id}`}>
                                                    <img src={photo.thumb_image || photo.image} />
                                                  </a> 

                                                  <div style = {{display: 'none'}} id = {`forCaption${photo.id}`}>
                                                    <div style = {{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                                      <img src={photo.image ? photo.image : photo.thumb_image} style = {{marginBottom: '30px', maxHeight: '80vh', maxWidth: '70vw', minHeight: '80vh'}}/>
                                                      <a href = {`/profile/${photo.author_id}`}  style = {{textAlign: 'center'}}>{photo.author_title}</a>
                                                    </div>
                                                  </div>
                                                </div>
                                            }
                                        </li>
                            })
                    }
                    </ul>
                    : null  
                }
                
            </div>

            

            <div className="social-activity" style={{alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{display:'flex', flexDirection:'row'}}>
                    {
                        (pack.is_already_liked || pack.is_already_disliked) || !this.props.session.isLoggedIn ?
                        [
                            <div key='1' className="social-activity__item like like-disabled" title={likeTitle}>{pack.likes_count}</div>,
                            <div key='2' className="social-activity__item dislike dislike-disabled" title={likeTitle}>{pack.dislikes_count}</div>
                        ]
                        :
                        [
                            <div key='1' className="social-activity__item like" onClick={() => this.props.handleLike(pack)} title="Проголосовать">{pack.likes_count}</div>,
                            <div key='2' className="social-activity__item dislike" onClick={() => this.props.handleDislike(pack)} title="Проголосовать">{pack.dislikes_count}</div>
                        ]
                    }
                    <div className="social-activity__item share" title="Поделиться">
                        <div className="social-icons">
                            <VKShareButton className="sc-vk" url={`${window.location.origin}/buy/single/${pack.id}`} />
                            {/* <GooglePlusShareButton className="sc-gl" url={`${window.location.origin}/buy/single/${pack.id}`} /> */}
                            <TwitterShareButton className="sc-tw" url={`${window.location.origin}/buy/single/${pack.id}`} />
                            <FacebookShareButton className="sc-fb" url={`${window.location.origin}/buy/single/${pack.id}`} />
                        </div>
                    </div>

                </div>

                {getButton(pack, this.props.session.isLoggedIn, this.props.onBuyClick)}

            </div>
        </li>
    )
  }        
}

export default OrderListItem


// WEBPACK FOOTER //
// ./src/components/BuyReady/OrderListItem.js